<template>
  <div class="containerFull_tennisChinaOpen">
    <TennisCommon
      :bigSportsList="bigSportsList"
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></TennisCommon>
  </div>
</template>

<script>
// 中国网球公开赛 容器
import TennisCommon from './tennis_common'
import containerFull_data from '@mixins/tennis/chinaOpen/containerFull_data'
export default {
  name: 'containerFull_tennisChinaOpen',
  mixins: [containerFull_data],
  components: {
    TennisCommon,
  },
}
</script>
